import React from 'react';
import PropTypes from 'prop-types';

const BackgroundSection = ({
  backgroundImage,
  overlayImage,
  children,
  className = '',
  backgroundClassName = '',
  overlayClassName = '',
  contentClassName = '',
}) => {
  return (
    <section
      className={`relative flex flex-col md:flex-row items-center md:justify-between px-6 py-12 md:px-28 md:py-0 items-center gap-12 md:h-[439px] ${className}`}
    >
      {backgroundImage && (
        <img
          src={backgroundImage}
          alt="background"
          className={`absolute w-full h-full md:h-[439px] top-0 left-0 right-0 z-10 ${backgroundClassName}`}
        />
      )}
      {overlayImage && (
        <img
          src={overlayImage}
          alt="overlay"
          className={`absolute w-full h-full md:h-[439px] top-0 left-0 right-0 z-10 ${overlayClassName}`}
        />
      )}
      <div className={`z-20 ${contentClassName}`}>{children}</div>
    </section>
  );
};

BackgroundSection.propTypes = {
  backgroundImage: PropTypes.string,
  overlayImage: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  backgroundClassName: PropTypes.string,
  overlayClassName: PropTypes.string,
  contentClassName: PropTypes.string,
};

export default BackgroundSection;
